export default ({ data }) => {
  return {
    creative_name: data.imageName ?? '',
    creative_slot: data.origin ?? '',
    location_id: data.origin ? `${data.origin}_${data.index}` : `${data.index}`,
    promotion_id: data.imageName ?? '',
    promotion_name: data.imageName ?? '',
  }
}
